<div class="menu-payment-container">
  <div class="menu-payment-header">
    <button type="button" class="back-button" (click)="goBack()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#12314F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      {{ 'menu_management.title' | translate }}
    </button>
  </div>

  <div class="order-summary">
    @for (item of selectedItems; track item.id) {
      @if (item.hasQuantity && (item.selectedQuantity || 0) > 0) {
        <div class="order-item-row">
          <span class="order-item-name">{{ item.name }}</span>
          <div class="order-item-prices">
            <span class="order-item-qty">{{ item.selectedQuantity }}×</span>
            <span class="order-item-primary">{{ item.quantity }} ֏</span>
            <span class="order-item-secondary">{{ toUsd(item.quantity) | number:'1.1-1' }}$</span>
          </div>
        </div>
      }
      @if (!item.hasQuantity) {
        <div class="order-item-row">
          <span class="order-item-name">{{ item.name }}</span>
          <div class="order-item-prices">
            <span class="order-item-primary">{{ item.price }} ֏</span>
            <span class="order-item-secondary">{{ toUsd(item.price) | number:'1.1-1' }}$</span>
          </div>
        </div>
      }
    }
    @if (selectedItems.length === 0) {
      <div class="order-empty">{{ 'menu_management.no_items_selected' | translate }}</div>
    }
    <div class="order-total-row">
      <span class="order-total-label">{{ 'fee.total' | translate }}</span>
      <div class="order-total-prices">
        <span class="order-total-secondary">{{ totalUsd | number:'1.1-1' }}$</span>
        <span class="order-total-primary">{{ total }} ֏</span>
      </div>
    </div>
  </div>

  <div class="payment-part">
    <div class="qr-or-share-line">
      <div class="share-section">
        <p class="share-title">{{ 'cards_by_qr.share_with_friend' | translate }}</p>
        <div class="share-buttons">
          <button class="share-button qr-button" (click)="showQR($event)">
            <span class="button-icon">
              <img src="/assets/svg/qr-icon.svg" alt="Qr Icon" width="24" height="24"/>
            </span>
            {{ 'individual_card.show_qr' | translate }}
          </button>
          <button class="share-button link-button" (click)="shareLink()">
            <span class="button-icon">
              <img src="/assets/svg/share-icon.svg" alt="Share Icon" width="24" height="24"/>
            </span>
            {{ 'cards_by_qr.share_link' | translate }}
          </button>
        </div>
      </div>
      <div class="divider">
        <span class="divider-text">{{ 'cards_by_qr.or' | translate }}</span>
      </div>
    </div>

    <div class="payment-part-select-frame">
      <span class="tw-text">{{ 'cards_by_qr.transfer_with' | translate }}</span>
      <button class="w-100 pay-with-card" (click)="pay(PaymentMethod.NEW_CREDIT_CARD)">
        <span class="size-controller">{{ 'payment.pay_with_new_credit_card' | translate }}</span>
        <img src="assets/payment-type/credit-card.svg" alt="Credit Card" class="pay-with-card-icon">
        <mat-icon class="plus-icon">add</mat-icon>
      </button>
      @if (creditCard) {
        <button class="w-100 pay-with-card" (click)="pay(PaymentMethod.EXISTING_CREDIT_CARD)">
          <span class="size-controller">{{ 'cards_by_qr.credit_card_masked' | translate:{ digits: getCreditCardLastNumbers } }}</span>
          <img src="assets/payment-type/credit-card.svg" alt="Credit Card" class="pay-with-card-icon">
        </button>
      }
      <div class="payment-categories">
        @for (category of paymentCategories; track category.code) {
          <button
            class="payment-cat-button"
            [class.disabled]="category.disabled"
            [disabled]="category.disabled"
            (click)="onPaymentCategoryClick(category)"
          >
            <img [src]="getLogoUrl(category.code)" [alt]="category.alt" [class]="category.imageClass || ''">
          </button>
        }
      </div>
    </div>
  </div>
</div>
